export const HTTP_OK = 200;
export const HTTP_CREATED = 201;
export const HTTP_UPDATED = 202;
export const HTTP_NO_CONTENT = 204;
export const HTTP_BAD_REQUEST = 400;
export const HTTP_UNAUTHORIZED = 401;
export const HTTP_FORBIDDEN = 403;
export const HTTP_NOT_FOUND = 404;
export const HTTP_UNPROCESSABLE_ENTITY = 422;
export const HTTP_INTERNAL_SERVER_ERROR = 500;
export const HTTP_UNAVAILABLE = 503;
export const HTTP_TIMEOUT = 504;

export const HTTP_CODES = {
  [HTTP_OK]: 'OK',
  [HTTP_CREATED]: 'CREATED',
  [HTTP_UPDATED]: 'UPDATED',
  [HTTP_NO_CONTENT]: 'NO_CONTENT',
  [HTTP_BAD_REQUEST]: 'BAD_REQUEST',
  [HTTP_UNAUTHORIZED]: 'UNAUTHORIZED',
  [HTTP_FORBIDDEN]: 'FORBIDDEN',
  [HTTP_NOT_FOUND]: 'NOT_FOUND',
  [HTTP_UNPROCESSABLE_ENTITY]: 'UNPROCESSABLE_ENTITY',
  [HTTP_INTERNAL_SERVER_ERROR]: 'INTERNAL_SERVER_ERROR',
  [HTTP_UNAVAILABLE]: 'UNAVAILABLE',
  [HTTP_TIMEOUT]: 'TIMEOUT'
};

export const ERROR_CODES_SPO = {
  CONTACT_WITH_EMAIL_EXISTS: 'PER06',
  CONTACT_WITH_NAME_EXISTS: 'PER06',
  CONTACT_WITH_NO_PERMISSION: 'PER02'
};
